<div class="wrap">
  <div *ngFor="let it of item">
    <mat-card>
      <div class="thumbnail">
        <div class="thumbnail_img_and_content">
          <div class="thumbnail_img">
            <img [src]="it.image" alt="fvv">
          </div>
          <div class="thumbnail_content">
            <h3>{{it.label}}</h3>
            <p>{{it.valeur}}</p>
          </div>
        </div>
      </div>
    </mat-card>
  </div>
</div>